import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TalentpoolService } from 'src/app/_services/talentpool.service';
import { CreateTalentpoolComponent } from '../create-talentpool/create-talentpool.component';
import { ShareTalentpoolsModalComponent } from 'src/app/share-talentpools-modal/share-talentpools-modal.component';

@Component({
  selector: 'app-talentpool-details',
  templateUrl: './talentpool-details.component.html',
  styleUrls: ['./talentpool-details.component.scss']
})
export class TalentpoolDetailsComponent implements OnInit {
  talentpoolslist: any[] = [];
  talentpoolid: any
  talentpooldetails: any
  successMessage: string = ''
  errorMessage: string = ''
  @ViewChild('deleteTalentpoolmodal') deleteTalentpoolmodal: TemplateRef<any>;
  selectedtalentpools: any = []
  isSharedTalentpool: boolean = false;

  constructor(private talentpoolservice: TalentpoolService, private _localstorageservice : LocalStorageService, 
    private router: Router, private modalService: NgbModal, private route: ActivatedRoute) { }

  ngOnInit() {
    this.talentpoolid = this.route.snapshot.params['id'];

    this.talentpoolservice.talentPoolDetails.subscribe((talentPoolData) => {
      this.talentpoolslist = talentPoolData ? talentPoolData.talentpools : [];
    });
    if (this.talentpoolid) {
        this.isSharedTalentpool = true;
        const sharedTalentPoolData = this._localstorageservice.getItem('sharedTalentPoolDetails') ? JSON.parse(this._localstorageservice.getItem('sharedTalentPoolDetails')) : null;
        this.talentpooldetails = sharedTalentPoolData ? (sharedTalentPoolData.talentpools || []).find((tp: any) => tp.talentpoolid == this.talentpoolid) : null;
        if(!this.talentpooldetails) this.getTalentpoolList();
    }
  }

  getTalentpoolList() {
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).subscribe(async (res: any) => {
      if (res.status == "success") {
        this._localstorageservice.setItem('talentPoolDetails', JSON.stringify(res?.data) || null);
        this.talentpoolservice.setTalentPoolDetails(res?.data || null);
        this.talentpoolslist = res.data.talentpools
        if (this.router.url.includes('talentpool')) {
          this.talentpoolid = this.router.url.split('/')[3]
          const currentTalentpoolDetails = res.data.talentpools.filter((x) => { return x.talentpoolid == this.talentpoolid })[0];
          if(currentTalentpoolDetails) {
            this.talentpooldetails = currentTalentpoolDetails;
          } else {
            this.isSharedTalentpool = true;
            const resp = await this.talentpoolservice.getSharedTalentpoolsList(this._localstorageservice.getItem('usernumber')).toPromise();
            if(resp && resp.status === 'success') {
              this.talentpooldetails = (resp?.data?.talentpools || []).find((tp: any) => tp.talentpoolid == this.talentpoolid);
            }  
          }
          // this.talentpoolnumber = this.talentpooldetails.talentpoolnumber
          // this.getCandidateList()
        }
        else {
          // this.talentpoolnumber = null
          // this.getCandidateList()
        }
      }
    })

  }

  editTalentpoolDetails() {
    const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.TalentpoolIDtoEdit = this.talentpooldetails.talentpoolnumber
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'talentpool-edited') {
        this.toastmessage("Talentpool Edited Successfully", 'success')
        this.getTalentpoolList()
      }
    })
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  deleteTalentpoolConfirmation(talent) {
    const confirmRef = this.modalService.open(this.deleteTalentpoolmodal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    this.selectedtalentpools.push(talent.talentpoolnumber)

  }

  deleteTalentpool() {
    let data = {
      talentpoolnumbers: this.selectedtalentpools,
      usernumber: this._localstorageservice.getItem('usernumber')
    }

    this.talentpoolservice.removetalentpoolsinbulk(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.modalService.dismissAll();
        this.successMessage = "Talentpool Deleted Successfully"
        this.toastmessage(this.successMessage, "success")
        this.getTalentpoolList()
      }
      else {
        this.errorMessage = "Something Went Wrong"
        this.toastmessage(this.errorMessage, "error")
      }
    })
  }

  previewtalentpoollist() {
    this.router.navigate(['/talent/talentpool'])
  }

  gettalentpoolcounts(event) {
    if(event == 'refresh') {
      this.getTalentpoolList()
    }
  }

  triggerTalentpoolSharing() {
    const selectedTalentpools = [this.talentpooldetails];
    const modalRef = this.modalService.open(ShareTalentpoolsModalComponent, { size: 'lg', backdrop: 'static', keyboard: false, centered: true });
    modalRef.componentInstance.selectedTalentpools = selectedTalentpools;
    modalRef.componentInstance.bulkSharing = false;
    modalRef.result
      .then((res: any) => {
        if(res === 'user-dismissed') return;
        this.successMessage = res;
      })
      .catch((err: any) => {
        this.errorMessage = err;
      })
      .finally(() => {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      });
  }

}
